import { LoadingSpinner, Header } from '@components/Generic'
import { observer } from 'mobx-react'
import { type CSSProperties, useContext, useEffect, useState } from 'react'
import { StoreContext } from '@store/Root.store'
import { devLog } from '@methods/devLog'
import { axiosInstance } from '@methods/axiosConfig'
import { forceRedirect } from '@methods/forceRedirect'
import { useInterval } from 'usehooks-ts'
import { usePageVisibility } from '@/hooks/usePageVisibility'
import { API_URL, ONBOARDING_SERVICE_PATH } from '@constants/apiUrl'

interface PollingResponse {
  status: string
  shouldWait: boolean
  proceedUrl?: string
}

export const VerifyingPage = observer(() => {
  const store = useContext(StoreContext)
  const { pixelSpeak: trans } = store.TranslationsState.translations

  const [shouldWait, setShouldWait] = useState(true)
  const [shouldPoll, setShouldPoll] = useState(true)

  const isVisible = usePageVisibility()

  const checkStatus = async (): Promise<PollingResponse | undefined> => {
    try {
      const res = await axiosInstance.get<PollingResponse>(
        `${API_URL}/${ONBOARDING_SERVICE_PATH}/waiting`,
        {
          withCredentials: true,
        }
      )

      if (!res.data.shouldWait && res?.data?.proceedUrl) {
        setShouldWait(false)

        forceRedirect(res.data.proceedUrl)
      }

      return res.data
    } catch (e) {
      devLog(e)
    }
  }

  useEffect(() => {
    setShouldPoll(isVisible)
  }, [isVisible])

  useEffect(() => {
    shouldPoll && checkStatus()
  }, [shouldPoll])

  useInterval(checkStatus, shouldWait && shouldPoll ? 3000 : null)

  return (
    <div className="page-container mobile-m-0">
      <div className="layout__margined-with-height">
        <Header>{trans.verifying}</Header>
      </div>
      <LoadingSpinner />
    </div>
  )
})
